import { render } from "./Services.vue?vue&type=template&id=4b678330"
import script from "./Services.vue?vue&type=script&lang=js"
export * from "./Services.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__